import React from "react";
import { IMAGES, PHONES, toTel } from "../../mock";
import { Truck } from "lucide-react";

const MovingSection = () => {
  return (
    <section className="py-4">
      <div className="max-w-[820px] mx-auto px-6 text-center">
        <h2 className="text-[26px] md:text-[30px] font-bold leading-snug" style={{ color: "var(--me-heading)" }}>
          Vous déménagez bientôt ?
          <br />
          On s'occupe de tout.
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl shadow-[0_14px_40px_rgba(20,40,76,0.14)]">
          <img
            src={IMAGES.moving}
            alt="Personne portant des cartons lors d'un déménagement"
            width={960}
            height={640}
            loading="lazy"
            decoding="async"
            className="w-full h-auto object-cover"
          />
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href={toTel(PHONES.moving)}
            data-testid="moving-cta"
            aria-label={`Ligne prioritaire déménagement, appeler le ${PHONES.moving}`}
            className="flex flex-col items-center rounded-full px-12 py-3.5 text-white shadow-[0_10px_24px_rgba(242,101,34,0.30)] transition-colors"
            style={{ backgroundColor: "var(--me-orange)" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-orange-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-orange)")}
          >
            <div className="flex items-center gap-2 text-[19px] font-bold tracking-wide">
              <Truck className="h-5 w-5" aria-hidden="true" />
              <span>Parler à un conseiller</span>
            </div>
            <span className="text-[12px] opacity-95">Ligne prioritaire déménagement</span>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5">
          <div className="rounded-2xl bg-white border border-[#eceef3] shadow-[0_4px_18px_rgba(20,40,76,0.05)] px-6 py-7">
            <p className="text-[17px] font-semibold" style={{ color: "var(--me-heading)" }}>
              Nous comparons les tarifs de fournisseurs partenaires et historiques
            </p>
            <div className="mt-5 flex justify-center">
              <img
                src={IMAGES.partners}
                alt="Fournisseurs partenaires"
                width={640}
                height={109}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto object-contain"
              />
            </div>
          </div>
          <div className="rounded-2xl bg-white border border-[#eceef3] shadow-[0_4px_18px_rgba(20,40,76,0.05)] px-6 py-7">
            <p className="text-[17px] font-semibold" style={{ color: "var(--me-heading)" }}>
              Electricité distribuée sur les réseaux GrDF et Enedis.
            </p>
            <p className="mt-2 text-[14px]" style={{ color: "var(--me-text)" }}>
              L'énergie est notre avenir, économisons-la.
            </p>
            <div className="mt-5 flex justify-center">
              <img
                src={IMAGES.erdfEnedis}
                alt="Réseaux GrDF et Enedis"
                width={320}
                height={56}
                loading="lazy"
                decoding="async"
                className="h-9 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MovingSection;
